import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

import { HHInput } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { resetPassword } from '../actions';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      newPassword: Yup.string()
        .min(8, translate('form.error.string.min'))
        .max(32, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required')),
      confirmPassword: Yup.string()
        .min(8, translate('form.error.string.min'))
        .max(32, translate('form.error.string.max'))
        // eslint-disable-next-line func-names
        .test('matchPasswords', translate('form.error.mixed.matchPasswords'), function (value) {
          const { newPassword } = this.parent;
          return newPassword === value;
        })
    }),
  mapPropsToValues: () => ({
    newPassword: '',
    confirmPassword: ''
  }),
  handleSubmit: ({ newPassword }, { props, setSubmitting }) => {
    const { resetToken } = props.match.params;
    props.resetPassword(newPassword, resetToken).then(failed => {
      if (failed) setSubmitting(false);
    });
  },
  displayName: FORM_NAME.NEW_PASSWORD_FORM
});

const ResetPasswordForm = ({ handleSubmit, isSubmitting, translate }) => (
  <Form inverted onSubmit={handleSubmit}>
    <Form.Field>
      <label htmlFor='newPassword'>{translate('New Password')}</label>
      <Field
        name='newPassword'
        component={HHInput}
        otherProps={{
          id: 'newPassword',
          className: 'g-rounded',
          placeholder: translate('New Password'),
          type: 'password'
        }}
      />
    </Form.Field>
    <Form.Field>
      <label htmlFor='confirmPassword'>{translate('form.confirmPassword')}</label>
      <Field
        name='confirmPassword'
        component={HHInput}
        otherProps={{
          id: 'confirmPassword',
          className: 'g-rounded',
          placeholder: translate('form.confirmPassword'),
          type: 'password'
        }}
      />
    </Form.Field>
    <Button
      primary
      fluid
      disabled={isSubmitting}
      loading={isSubmitting}
      className='g-rounded g-gradient text-uppercase'
      type='submit'
      size='big'
    >
      {translate('Reset Password')}
    </Button>
  </Form>
);

export default compose(
  withLocalize,
  withRouter,
  connect(null, { resetPassword }),
  formikEnhancer
)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/resetPasswordForm.js